function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.96338 13.908V20.194C1.96338 26.4799 4.48338 28.9999 10.7694 28.9999H18.3154C24.6014 28.9999 27.1214 26.4799 27.1214 20.194V13.908",
    stroke: "#333333",
    style: {
      stroke: "#333333",
      stroke: "color(display-p3 0.2000 0.2000 0.2000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5494 15C17.1114 15 19.0014 12.914 18.7494 10.352L17.8254 1H11.2874L10.3494 10.352C10.0974 12.914 11.9874 15 14.5494 15Z",
    stroke: "#333333",
    style: {
      stroke: "#333333",
      stroke: "color(display-p3 0.2000 0.2000 0.2000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3833 15C26.2113 15 28.2833 12.704 28.0033 9.88999L27.6113 6.03999C27.1073 2.4 25.7073 1 22.0393 1H17.7693L18.7493 10.814C18.9873 13.124 21.0733 15 23.3833 15Z",
    stroke: "#333333",
    style: {
      stroke: "#333333",
      stroke: "color(display-p3 0.2000 0.2000 0.2000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64534 15C7.95534 15 10.0413 13.124 10.2653 10.814L10.5733 7.71999L11.2453 1H6.97534C3.30735 1 1.90735 2.4 1.40335 6.03999L1.02535 9.88999C0.745348 12.704 2.81735 15 5.64534 15Z",
    stroke: "#333333",
    style: {
      stroke: "#333333",
      stroke: "color(display-p3 0.2000 0.2000 0.2000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5493 22C12.2113 22 11.0493 23.162 11.0493 25.5V29H18.0493V25.5C18.0493 23.162 16.8873 22 14.5493 22Z",
    stroke: "#333333",
    style: {
      stroke: "#333333",
      stroke: "color(display-p3 0.2000 0.2000 0.2000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.63168c26ce8cc62671232d594fe6dc19.svg";
export { ForwardRef as ReactComponent };